export default "__VITE_ASSET__S8E$Xt5Q__"